import React from "react";
import PropTypes from 'prop-types';
import ReactPaginate from "react-paginate";

const PaginationComponent = React.memo(({ pages, setOpts, currentPage }) => {
  return (
    <>
      <ReactPaginate
        previousLabel="< Anterior"
        nextLabel="Siguiente >"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        pageCount={pages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={3}
        forcePage={currentPage}
        onPageChange={({ selected }) => {
          setOpts((prevOpts) => ({ ...prevOpts, page: selected }));
        }}
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />
    </>
  );
});

PaginationComponent.displayName = "PaginationComponent";

PaginationComponent.propTypes = {
  pages: PropTypes.number,
  setOpts: PropTypes.func,
  currentPage: PropTypes.number,
};

export default PaginationComponent;
